<template>
  <!-- 筛选条件区域 -->
  <el-form :inline="true" :model="queryParams" class="search-form">
    <el-form-item :label="$t('message.reaTimePlot.companyDeviceTree')">
      <el-cascader
        v-model="currentDeviceId"
        :data="deviceList"
        :options="deviceTreeOptions"
        :props="deviceTreeProps"
        clearable
        :placeholder="$t('message.reaTimePlot.selectDevice')"
        @change="handleDeviceChange"
        class="filter-control"
      ></el-cascader>
    </el-form-item>
    
    <el-form-item :label="$t('message.reaTimePlot.monitorVariable')">
      <VariableSelector
        v-model="selectedVariables" 
        :device-id="currentDeviceId"
        @change="handleVariableChange"
        class="filter-control variable-selector"
        style="width: 300px"
      />
    </el-form-item>

    <el-form-item :label="$t('message.reaTimePlot.MonitoringDuration')">
      <el-input-number v-model="monitoringDuration" :min="1" />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="rollCallClick">
        {{ $t('message.reaTimePlot.rollCall') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref } from 'vue'
import VariableSelector from '@/components/views/VariableSelector.vue'

const currentDeviceId = ref(2)
const queryParams = ref({}) // 定义表单查询参数对象

const handleVariableChange = (newSelection) => {
  console.log('变量选择变化:', newSelection)
}
</script>

<style scoped>
/* 搜索表单样式 */
.search-form {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 表单元素间距调整 */
.search-form :deep(.el-form-item) {
  margin-right: 16px;
  margin-bottom: 0;
}

/* 标签样式调整 */
.search-form :deep(.el-form-item__label) {
  width: auto;
  padding-right: 12px;
  color: #606266;
  font-size: 14px;
}

/* 统一控制元素样式 */
.filter-control {
  min-width: 180px;
}

/* 级联选择器高度调整 */
.filter-control:deep(.el-cascader .el-input__inner) {
  height: 32px;
  line-height: 32px;
}

/* 变量选择器高度调整 */
.variable-selector:deep(.selector-header) {
  height: 32px;
  min-height: 32px;
  line-height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
}
</style>